import React from "react";

export default function MasterRowActions({
  onEdit,
  onDelete,
  showDelete = true,
}: {
  onEdit: () => void;
  onDelete?: () => void;
  showDelete?: boolean;
}) {
  return (
    <>
      <button className="font-size" onClick={onEdit} type="button">
        <i
          className="mdi mdi-pencil-box text-md text-primary font-size"
          title="Edit"
        ></i>
      </button>
      {showDelete && onDelete ? (
        <button className="font-size" onClick={onDelete} type="button">
          <i
            className="mdi mdi-delete-forever text-md text-danger mx-2 font-size"
            title="Delete"
          ></i>
        </button>
      ) : null}
    </>
  );
}
